export const PRIORITY_PIN = [
  { label: 'high', key: 'HIGH' },
  { label: 'medium', key: 'MEDIUM' },
  { label: 'low', key: 'LOW' },
]

export default {}
